import React from 'react';

interface PrivacyPolicyProps {
  onBack: () => void;
}

export const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onBack }): React.ReactElement => {
  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      background: '#0a0e14',
      overflowY: 'auto',
      padding: '40px 20px',
      boxSizing: 'border-box',
    }}>
      <div style={{
        maxWidth: '700px',
        margin: '0 auto',
        textAlign: 'left',
        color: '#e2e8f0',
      }}>
        <button
          onClick={onBack}
          style={{
            background: '#21262d',
            border: '1px solid #30363d',
            color: '#e2e8f0',
            padding: '8px 16px',
            cursor: 'pointer',
            marginBottom: '24px',
            fontSize: '12px',
          }}
        >
          ← Back to Sign In
        </button>

        <h1 style={{ textAlign: 'center', marginBottom: '8px' }}>Privacy Policy</h1>
        <p style={{ textAlign: 'center', color: '#8b949e', fontSize: '12px', marginBottom: '32px' }}>
          Last updated: December 9, 2025
        </p>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>1. Introduction</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            Welcome to Grand Online ("we," "our," or "us"). We respect your privacy and are committed 
            to protecting your personal data. This privacy policy explains how we collect, use, and 
            safeguard your information when you use our game.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>2. Information We Collect</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6', marginBottom: '12px' }}>
            We collect the following types of information:
          </p>
          <ul style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li><strong>Account Information:</strong> Email address and authentication data when you sign in via Google or Discord OAuth.</li>
            <li><strong>Game Data:</strong> Character names, game progress, in-game statistics, and gameplay preferences.</li>
            <li><strong>Technical Data:</strong> IP address, browser type, and device information for security and analytics purposes.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>3. How We Use Your Information</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6', marginBottom: '12px' }}>
            We use your information to:
          </p>
          <ul style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>Provide and maintain the game service</li>
            <li>Save and sync your game progress across devices</li>
            <li>Authenticate your identity and secure your account</li>
            <li>Improve game performance and user experience</li>
            <li>Communicate important updates about the service</li>
          </ul>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>4. Third-Party Services</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            We use the following third-party services:
          </p>
          <ul style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li><strong>Google OAuth:</strong> For authentication. Subject to Google's Privacy Policy.</li>
            <li><strong>Discord OAuth:</strong> For authentication. Subject to Discord's Privacy Policy.</li>
            <li><strong>Supabase:</strong> For database and authentication services. Subject to Supabase's Privacy Policy.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>5. Data Security</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            We implement appropriate security measures to protect your personal information. However, 
            no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>6. Data Retention</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            We retain your data for as long as your account is active or as needed to provide services. 
            You may request deletion of your account and associated data at any time by contacting us.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>7. Your Rights</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6', marginBottom: '12px' }}>
            You have the right to:
          </p>
          <ul style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent for data processing</li>
          </ul>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>8. Children's Privacy</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            Our service is not intended for children under 13 years of age. We do not knowingly collect 
            personal information from children under 13.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>9. Changes to This Policy</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            We may update this privacy policy from time to time. We will notify you of any changes by 
            posting the new policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>10. Contact Us</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            If you have any questions about this Privacy Policy, please contact us through our game support channels.
          </p>
        </section>

        <button
          onClick={onBack}
          style={{
            background: '#21262d',
            border: '1px solid #30363d',
            color: '#e2e8f0',
            padding: '8px 16px',
            cursor: 'pointer',
            marginTop: '16px',
            fontSize: '12px',
            width: '100%',
          }}
        >
          ← Back to Sign In
        </button>

        <div style={{ height: '40px' }} />
      </div>
    </div>
  );
};
